/** Topbar account menu: identity, profile/settings links, sign out */

import { useCallback, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { LogOut, Settings, User } from 'lucide-react'
import { useAuth } from '../../hooks/use-auth'
import { signOut } from '../../lib/sign-out'
import { useT } from '../../i18n'
import { useDismiss } from './use-dismiss'

const itemClass = 'flex w-full cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-left text-sm text-fg-muted hover:bg-surface-hover hover:text-fg'

export function UserMenu() {
  const t = useT()
  const { user } = useAuth()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const close = useCallback(() => setOpen(false), [])
  useDismiss(ref, open, close)


  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={t('topbar.userMenu')}
        className="flex h-9 w-9 cursor-pointer items-center justify-center overflow-hidden rounded-full border border-border bg-surface-muted text-fg-muted hover:border-border-strong"
      >
        {user?.avatarUrl ? <img src={user.avatarUrl} alt="" className="h-full w-full object-cover" /> : <User className="h-4 w-4" />}
      </button>

      {open && (
        <div role="menu" className="absolute right-0 top-11 z-40 w-60 max-w-[calc(100vw-2rem)] rounded-lg border border-border bg-surface-raised p-1 shadow-xl">
          {user && (
            <div className="border-b border-border px-2.5 pb-2 pt-1.5">
              <p className="truncate text-sm font-medium text-fg">{user.name}</p>
              <p className="truncate text-xs text-fg-subtle">{user.email}</p>
            </div>
          )}
          <div className="pt-1">
            <Link role="menuitem" to="/settings/profile" onClick={close} className={itemClass}>
              <User className="h-4 w-4" aria-hidden="true" />
              {t('nav.profile')}
            </Link>
            <Link role="menuitem" to="/settings" onClick={close} className={itemClass}>
              <Settings className="h-4 w-4" aria-hidden="true" />
              {t('nav.settings')}
            </Link>
            <button role="menuitem" type="button" onClick={() => void signOut()} className={itemClass}>
              <LogOut className="h-4 w-4" aria-hidden="true" />
              {t('topbar.signOut')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
